import React from 'react';

const AboutUsPage = () => {
  return (
    <div className="bg-gray-100 p-6">
      <div className="container mx-auto">
        <h1 className="text-3xl font-semibold mb-6">About Learnsource</h1>
        <p className="text-lg mb-6">
          Learnsource is a passionate community-driven platform committed to transforming the education landscape. Our primary goal is to break down the barriers to knowledge and opportunity, ensuring that every individual has the tools they need to succeed.
        </p>
        <p className="text-lg mb-6">
          At Learnsource, our core motto is "Unlock Your Potential." We firmly believe that every person has untapped potential, and it's our mission to help them unleash it. We're on a journey to provide accessible, high-quality educational resources and create a vibrant community of lifelong learners.
        </p>
        <p className="text-lg mb-6">
          We recognize the pressing issues in today's education and job market. Access to premium software, affordable courses, and internship opportunities can be challenging. Learnsource is the solution to these problems. We offer free access to premium software, discounts on courses, opportunities to earn certificates, and real-time internship openings. Our aim is to empower individuals, regardless of their financial status, to pursue their dreams and launch their careers with confidence.
        </p>
        <p className="text-lg mb-6">
          Learnsource is more than just a platform; it's a community united by a shared passion for learning and growth. Join us in our mission to create a world where education is accessible to all, and where individuals can truly unlock their potential.
        </p>
      </div>
    </div>
  );
};

export default AboutUsPage;
